import { takeLatest, take, call, cancelled, put } from 'redux-saga/effects';
import { END, eventChannel } from 'redux-saga';

import { AUTH_AZURE_REDIRECT, AUTH_AZURE_ERROR_CODE } from '../../constants';
import { API_URI, WEB_APP_URL } from '../../constants/env';
import * as error from '../ui/error';
import {
  consts as authorizationAzureConsts,
  actions as authorizationAzureActions,
} from './authAzure';
import { actions as loginAzureActions } from './login-azure';
import { getAuthAzureErrorMessage } from '../../utils/auth/getAuthAzureErrorMessage';

const { NOT_CONFIRMED } = AUTH_AZURE_ERROR_CODE;

function handlePostMessage() {
  return eventChannel(emitter => {
    window.addEventListener('message', receiveMessage, false);
    function receiveMessage(event) {
      const safeOrigin = WEB_APP_URL.slice(0, -1);
      if (event.origin !== safeOrigin) return;
      emitter(event.data);
      emitter(END);
    }
    return () => {
      window.removeEventListener('message', receiveMessage, false);
    };
  });
}

function* handleAuthAzureWorker({ payload: { intl, signUpFlow } }) {
  const successRedirectUrl = `${WEB_APP_URL}${AUTH_AZURE_REDIRECT.SUCCESS}`;
  const errorRedirectUrl = `${WEB_APP_URL}${AUTH_AZURE_REDIRECT.ERROR}`;
  const signUpRedirectUrl = `${WEB_APP_URL}${AUTH_AZURE_REDIRECT.SIGN_UP}`;

  const redirectUrl = `${API_URI}azure_authentication/azure_omniauth?success_redirect_url=${successRedirectUrl}&error_redirect_url=${errorRedirectUrl}${
    signUpFlow ? `&registration_redirect_url=${signUpRedirectUrl}` : ''
  }&params=patient`;

  yield window.open(redirectUrl);

  const postMessageChannel = yield call(handlePostMessage);

  try {
    while (true) {
      const result = yield take(postMessageChannel);
      if (result.type === 'error') {
        yield put({
          type: error.consts.UPDATE,
          payload: {
            id: getAuthAzureErrorMessage(result.code, intl),
          },
          isStaticFlow: true,
          infoErrorIcon: result.code === NOT_CONFIRMED ? 'information' : null,
        });
      }
      if (result.type === 'success') {
        yield put(
          authorizationAzureActions.setCredentialForMfa({
            login: result.login,
            token: result.token,
          }),
        );
        // ToDO bug BE
        if (signUpFlow) {
          yield put(authorizationAzureActions.setSuccessSignUpFlow());
        } else {
          yield put(loginAzureActions.send({ access_token: result.token }));
        }
      }
      if (result.type === 'sign_up') {
        yield put(authorizationAzureActions.setSuccessSignUpFlow());
      }
    }
  } finally {
    if (yield cancelled()) {
      postMessageChannel.close();
    }
  }
}

export function* authAzureSaga() {
  yield takeLatest([authorizationAzureConsts.INIT], handleAuthAzureWorker);
}



// WEBPACK FOOTER //
// ./src/redux/auth/auth-azure-saga.js